import React, { useState, useEffect } from 'react';
import { CommonLabeledComboProps } from '../../../types/common';
import Combobox from '../Combobox';
import ErrorLabel from '../ErrorLabel';
import InnerLabel from '../InnerLabel';

export const LabeledComboboxTestId = 'labeledcombobox-input';

export type LabeledComboboxProps = CommonLabeledComboProps;

const LabeledCombobox: React.FC<LabeledComboboxProps> = ({
  name,
  options,
  label,
  errorLabel,
  className = '',
  labelClassName,
  autoComplete,
  defaultValue,
  disabled,
  disablePlaceholder,
  readOnly,
  register,
  onBlur,
  onChange,
  onFocus,
  onKeyDown,
}: LabeledComboboxProps) => {
  const isTextbox = !options || !options.length;
  const [showAsPlaceholder, setShowAsPlaceholder] = useState(isTextbox);

  useEffect(() => {
    setShowAsPlaceholder(isTextbox);
  }, [setShowAsPlaceholder, isTextbox]);

  const handleOnFocus = (e: React.FocusEvent<HTMLInputElement>): void => {
    setShowAsPlaceholder(false);
    onFocus?.(e);
  };
  const handleOnBlur = (e: React.FocusEvent<HTMLInputElement>): void => {
    e.persist();
    setShowAsPlaceholder(
      isTextbox && (!e.target.value || e.target.value === '')
    );
    onBlur?.(e);
  };

  const labelClasses = `absolute ${
    labelClassName || ''
  } checkout-panel-form-label`;

  return (
    <div
      className={`m-2 ${className} relative`}
      data-testid={LabeledComboboxTestId}
    >
      <InnerLabel
        inputName={name}
        hasErrors={!!errorLabel}
        className={labelClasses}
        showAsPlaceholder={!disablePlaceholder && showAsPlaceholder}
      >
        {label}
      </InnerLabel>
      <Combobox
        name={name}
        displayText={label}
        options={options}
        hasErrors={!!errorLabel}
        className="pt-5 w-full pl-4 pb-1"
        register={register}
        disabled={disabled}
        readOnly={readOnly}
        onBlur={handleOnBlur}
        onKeyDown={onKeyDown}
        onFocus={handleOnFocus}
        autoComplete={autoComplete}
        defaultValue={defaultValue}
        onChange={onChange}
      />
      <ErrorLabel>{errorLabel}</ErrorLabel>
    </div>
  );
};

export default LabeledCombobox;
